var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress", attrs: { id: "progress-bar" } },
    [
      _vm.isMobile
        ? _c("input", {
            ref: "input",
            attrs: {
              type: "range",
              min: "0",
              max: _vm.interpolate(_vm.duration),
              tabindex: "-1",
              "aria-hidden": "true"
            },
            domProps: { value: _vm.interpolate(_vm.time) },
            on: {
              change: function($event) {
                return _vm.onChange($event.target.value)
              },
              input: function($event) {
                return _vm.onInput($event.target.value)
              }
            }
          })
        : _c("input", {
            ref: "input",
            attrs: {
              type: "range",
              min: "0",
              max: _vm.interpolate(_vm.duration),
              tabindex: "-1",
              "aria-hidden": "true"
            },
            domProps: { value: _vm.interpolate(_vm.time) },
            on: {
              change: function($event) {
                return _vm.onChange($event.target.value)
              },
              input: function($event) {
                return _vm.onInput($event.target.value)
              },
              mousemove: _vm.onMouseMove,
              mouseout: _vm.onMouseOut
            }
          }),
      _vm._v(" "),
      _c("span", { staticClass: "progress-range", style: _vm.rangeStyle }),
      _vm._v(" "),
      _vm._l(_vm.buffer, function(buffering, index) {
        return _c("span", {
          key: "buffer-" + index,
          staticClass: "progress-buffer",
          style: _vm.bufferStyle(buffering),
          attrs: { tabindex: "-1", "aria-hidden": "true" }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.quantiles, function(quantile, index) {
        return _c("span", {
          key: "track-" + index,
          staticClass: "progress-track",
          style: _vm.trackStyle(quantile),
          attrs: { tabindex: "-1", "aria-hidden": "true" }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chapters-progress" },
        _vm._l(_vm.chapters, function(chapter, index) {
          return _c("span", {
            key: index,
            staticClass: "indicator",
            style: _vm.chapterStyle(chapter),
            attrs: { tabindex: "-1", "aria-hidden": "true" }
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("span", {
        staticClass: "ghost-thumb",
        style: _vm.ghostStyle,
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "progress-thumb",
        class: { active: _vm.thumbActive },
        style: _vm.thumbStyle,
        attrs: { tabindex: "-1", "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("input", {
        staticClass: "visually-hidden",
        attrs: {
          type: "range",
          title: _vm.title,
          min: "0",
          max: "100",
          steps: "1"
        },
        domProps: { value: (_vm.time / _vm.duration) * 100 },
        on: {
          change: function($event) {
            _vm.onChange(($event.target.value / 100) * _vm.duration)
          },
          input: function($event) {
            _vm.onInput(($event.target.value / 100) * _vm.duration)
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }